import { Helpers } from "../../../../helpers/Helpers";
import { GetAntrepoOutByIdResponseAntrepoOutMessage } from "../../../../models/response/antrepoOut/GetAntrepoOutByIdResponse";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    antrepoOutMessagesRef: any
    antrepoOutMessages: GetAntrepoOutByIdResponseAntrepoOutMessage[]
}

const MessageHistory = ({
    antrepoOutMessagesRef,
    antrepoOutMessages
}: Props) => {
    return (
        <div className='containerPart' ref={antrepoOutMessagesRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Geçmiş</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>İşlem</th>
                                            <th>Kullanıcı</th>
                                            <th>Tarih</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoOutMessages.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoOutMessages.map((item, index) =>
                                                <tr>
                                                    <td>{item.message}</td>
                                                    <td>{item.createdUser}</td>
                                                    <td>{item.createdDate}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default MessageHistory;